'use strict'
module.exports = {
  NODE_ENV: 'production',
  BASE_URL: 'https://chat-api.lamusica.com',
  PUBNUB_SUB_KEY: 'sub-c-72282a40-00fd-11ec-a04b-221653618fb7',
  PUBNUB_PUB_KEY: 'pub-c-5a3225a4-19e6-4582-ba84-ae27eb4edabf'
}
